import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgMixerHorizontal = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.86667 3.2C4.98301 3.2 4.26667 3.91634 4.26667 4.8C4.26667 5.68366 4.98301 6.4 5.86667 6.4C6.75032 6.4 7.46667 5.68366 7.46667 4.8C7.46667 3.91634 6.75032 3.2 5.86667 3.2ZM3.2 5.33333C3.21782 5.33333 3.23544 5.33246 3.25282 5.33075C3.4989 6.54922 4.57565 7.46666 5.86667 7.46666C7.15768 7.46666 8.23443 6.54922 8.48051 5.33075C8.49789 5.33246 8.51551 5.33333 8.53333 5.33333H14.4C14.6945 5.33333 14.9333 5.09455 14.9333 4.8C14.9333 4.50545 14.6945 4.26666 14.4 4.26666H8.53333C8.51551 4.26666 8.49789 4.26754 8.48051 4.26925C8.23443 3.05076 7.15768 2.13333 5.86667 2.13333C4.57565 2.13333 3.4989 3.05076 3.25282 4.26925C3.23544 4.26754 3.21782 4.26666 3.2 4.26666H1.6C1.30545 4.26666 1.06667 4.50545 1.06667 4.8C1.06667 5.09455 1.30545 5.33333 1.6 5.33333H3.2ZM12.7472 11.7308C12.5011 12.9492 11.4243 13.8667 10.1333 13.8667C8.84231 13.8667 7.76557 12.9492 7.51949 11.7308C7.50211 11.7325 7.48449 11.7333 7.46667 11.7333H1.6C1.30545 11.7333 1.06667 11.4945 1.06667 11.2C1.06667 10.9055 1.30545 10.6667 1.6 10.6667H7.46667C7.48449 10.6667 7.50211 10.6675 7.51949 10.6692C7.76557 9.45077 8.84231 8.53333 10.1333 8.53333C11.4243 8.53333 12.5011 9.45077 12.7472 10.6692C12.7646 10.6675 12.7822 10.6667 12.8 10.6667H14.4C14.6945 10.6667 14.9333 10.9055 14.9333 11.2C14.9333 11.4945 14.6945 11.7333 14.4 11.7333H12.8C12.7822 11.7333 12.7646 11.7325 12.7472 11.7308ZM8.53333 11.2C8.53333 10.3163 9.24967 9.6 10.1333 9.6C11.017 9.6 11.7333 10.3163 11.7333 11.2C11.7333 12.0836 11.017 12.8 10.1333 12.8C9.24967 12.8 8.53333 12.0836 8.53333 11.2Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgMixerHorizontal)
const IconSvgMixerHorizontal = createIcon(ForwardRef, 'SvgMixerHorizontal')
export default IconSvgMixerHorizontal
